export default "__VITE_ASSET__4a94d565__"